export const cities = [
  { cityId: 0, cityName: "All" },
  { cityId: 1, cityName: "Mumbai" },
  { cityId: 2, cityName: "Pune" },
  { cityId: 3, cityName: "Delhi" },
  { cityId: 4, cityName: "Bengaluru" },
  { cityId: 5, cityName: "Hyderabad" },
  { cityId: 6, cityName: "Chennai" },
  { cityId: 7, cityName: "Ahmedabad" },
  { cityId: 8, cityName: "Kolkata" },
];
